import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../shared/loading/loading.service';

@Component({
  selector: 'my-page-not-found',
  template: require('./pagenotfound.component.html'),
  styles: [require('./pagenotfound.component.scss')]
})
export class PageNotFoundComponent implements OnInit {

  constructor(private loadingService: LoadingService) {
    // Do stuff
  }

  ngOnInit() {
    console.log('404 : Page Not Found');
    this.loadingService.hideLoading();
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/pagenotfound/pagenotfound.component.ts